<p class="">現場情報登録 / 変更</p>
<mat-card>
  <mat-card-header>
    <mat-card-title>現場図面設定</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-drawing-editor
      *ngIf="site"
      [site]="site"
      (drawingCanceled)="onDrawingCanceled()"
      (drawingSaved)="onDrawingSaved()"
    ></app-drawing-editor>
  </mat-card-content>

  <mat-card-header>
    <mat-card-title>山留図面設定</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-drawing-tilt-editor
      *ngIf="site && site.sensorRef?.tilt?.length"
      [site]="site"
      (drawingCanceled)="onDrawingCanceled()"
      (drawingSaved)="onDrawingSaved()"
    ></app-drawing-tilt-editor>
  </mat-card-content>
</mat-card>
